
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { PaypalLinkedService } from 'app/model/linkedservice/paypal.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'PayPalObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Paypal_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Paypal_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: PaypalLinkedService.MODEL // Linked service redefined
        }
    }
})
export class PaypalObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
